import SvgIcon from '@mui/material/SvgIcon';

interface Props {
  isSelected: boolean;
}

export const CardsTableHeadArrowUp = ({ isSelected }: Props) => {
  const fill = !isSelected ? '#656565' : '#D9D9D9';
  return (
    <SvgIcon sx={{ width: 6, height: 4 }}>
      <svg
        width="6"
        height="4"
        viewBox="0 0 6 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.99658 0L5.59255 3H0.40062L2.99658 0Z" fill={fill} />
      </svg>
    </SvgIcon>
  );
};
